import React, { Component } from "react";
import { linkageList } from "../../../network/api";
import Adapter from "./linkage-adapter"
import {useful_links } from "../../../resources/string/strings"
import ModalDetail from "./modal-linkage-detail";
import Loading from "../../util/page-loading";

class Linkage extends Component {
  state = {
    detailModalShow: false,
    detailModalAccessAllowed: false,
    selectedItem: undefined,
    data: undefined
  };

  componentDidMount() {
    this.callLinkageListApi();
  }

  render() {
    if (this.state.data === undefined || this.state.data === null){
      return <Loading/>
    } else {
    return (
      <div className="row mt-4" >

      <div className="mb-3 mt-2" style={{fontSize: 14, color: "black", textAlign: "right"}}>{useful_links}</div>

        {this.state.data !== undefined && this.state.data.length !== 0 && (
              <div className="row p-0 m-0"  >
                {this.state.data.map((item) => (
                  <Adapter
                    history={this.props.history}
                    key={item.id}
                    item={item}
                    onSelect={this.onSelect}
                  />
                ))}
              </div>
            )}

      <ModalDetail
          show={this.state.detailModalShow}
          onHide={this.handleLogoutModalClose}
          accessallowed={this.state.detailModalAccessAllowed}
          allowaccess={this.allowAccess}
          item={this.state.selectedItem}
          onlinkopen={this.onLinkOpen}
        />
      </div>

    );
                }
  }

  allowAccess = () => {
    this.setState({ detailModalAccessAllowed: true});
  }

  handleLogoutModalClose = () => {
    this.setState({ detailModalShow: false , detailModalAccessAllowed: false});
  };

  onSelect = (item) => {
    if (item !== undefined){
      this.setState({ selectedItem: item });

      if (item.links !== undefined && item.links !== null && item.links.length === 1 && item.permissionRequired !== undefined && item.permissionRequired !== null && !item.permissionRequired && (item.description === undefined || item.description === null || item.description.length === 0)){
        var link = item.links[0].link
        this.onLinkOpen(link)
      } else {
        if (!item.permissionRequired && item.links !== undefined && item.links !== null){
          this.setState({ detailModalAccessAllowed: true});
        }
        this.setState({ detailModalShow: true });
      }
    } 
  }

  onLinkOpen = (link) => {
    this.setState({ detailModalShow: false });
    window.open(link, '_blank', 'noreferrer');
  }
  
  /****
  ** NETWORK
  *****/

  callLinkageListApi() {
    this.setState({ loading: true })
    linkageList(this.handleLinkageLisApiSuccess, this.handleLinkageLisFailure);
  }

  handleLinkageLisApiSuccess = (data) => {
    this.setState({
      loading: false,
      data: data
    });
  };

  handleLinkageLisFailure = (error) => {
    this.setState({ loading: false });
  }

}

export default Linkage;
